var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.17,
    height: 23.26,
    viewBox: "0 0 24.17 23.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5cbc7f;\n      }\n\n      .cls-2 {\n        fill: #383838;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16636",
    "data-name": "Path 16636",
    className: "cls-1",
    d: "M14.47,10a.74.74,0,0,0-.23-.2A.73.73,0,0,0,14,9.77H12.52V7.3a.62.62,0,0,0-.62-.62H10.22a.62.62,0,0,0-.62.62V11a.63.63,0,0,0,.6.62l1.2,0v4.6a.34.34,0,0,0,.08.21.34.34,0,0,0,.42.09.35.35,0,0,0,.15-.17l2.46-5.75a.58.58,0,0,0,0-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16637",
    "data-name": "Path 16637",
    className: "cls-2",
    d: "M21.15,0H3A3,3,0,0,0,0,3H0V20.24a3,3,0,0,0,3,3H21.15a3,3,0,0,0,3-3h0V3a3,3,0,0,0-3-3ZM15.66,11.12,13.2,16.87a1.58,1.58,0,0,1-3-.63v-3.4A1.86,1.86,0,0,1,8.36,11V7.3a1.87,1.87,0,0,1,1.86-1.87h1.69A1.87,1.87,0,0,1,13.77,7.3V8.52H14a1.87,1.87,0,0,1,1.87,1.87,1.84,1.84,0,0,1-.16.73Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgi);
export default __webpack_public_path__ + "static/media/AGI.e9ca04004ea05ca6e50debd45657aad5.svg";
export { ForwardRef as ReactComponent };